/* global http google loadEventSliders loadEventGoogleMaps toggleEventsFilterModal scrollOnEvent */
const serviceFilterAsideMap = {
	el: {
		body: document.body,
		mainContainer: document.querySelector('.js-filter-map'),
		filterType: document.querySelectorAll('[data-filter-type]'),
		filterInputAndSelectListener: document.querySelectorAll('.js-filter-change-listener'),
		mapWithMarker: document.querySelector('.js-map-with-markers')
	},

	vars: {
		currentPage: 1,
		extraLargeAndUp: window.matchMedia('(min-width: 75em)')
	},

	fxHandleFilterOnChangeSelectOrInput(el) {
		// check if element exists
		if (!el) return

		// reset pagination
		this.vars.currentPage = 1

		// Responsible for set values of radio buttons and select elements on data attribute called 'data filter id' and make sure that when user select mobile version, the desktop version is selected as well
		toggleEventsFilterModal.fxHandleSelectAndInputValue(el)

		// filter results on change of radio button or select
		this.fxFilter(this.el.mainContainer)
	},

	fxUpdatePagination(el) {
		// check if element exists
		if (!el) return

		// set pagination to page selected
		this.vars.currentPage = el.textContent

		// Remove all active classes on options
		document.querySelectorAll('.js-filter-pagination-item').forEach(el => el.classList.remove('active'))

		// filter results on pagination selected
		this.fxFilter(this.el.mainContainer)
	},

	fxGetSelectedFilterForSummaryResults(filterId) {
		// get selected filter type
		const typeSelected = document.querySelector(`[data-filter-type='${filterId}'`)
		// save which select option has been selected
		const optionSelected = typeSelected.querySelector('select').options.selectedIndex
		// return text from this option selected - this way we make sure that we return the exact same value as the one in select element
		return typeSelected.querySelector('select').options[optionSelected].text
	},

	fxRenderSummaryResults(response, data) {
		if (response.status === 200) {

			// set the number of results with data.length
			document.querySelector('.js-filter-summary-counter').textContent = data.totalRecords

			// save variables for later use
			let filterRegion
			let filterLocation
			let filterCategories

			// populate variables 
			filterRegion = this.fxGetSelectedFilterForSummaryResults('region')
			filterLocation = this.fxGetSelectedFilterForSummaryResults('location')
			filterCategories = this.fxGetSelectedFilterForSummaryResults('category')

			// set each result with variables created above
			document.querySelector('.js-filter-summary-first-selected').textContent = filterRegion
			document.querySelector('.js-filter-summary-second-selected').textContent = filterLocation
			document.querySelector('.js-filter-summary-third-selected').textContent = filterCategories

		}

	},

	fxRenderAsideResults(response, data) {

		if (response.status === 200) {

			// first we need to get rid of the old results
			document.querySelectorAll('.aside-filter-map__item').forEach(el => el.remove())

			// set variables for later use
			let cardsAsideFilterMap
			let imageSliderItem

			// CARDS
			//then we need to render the new results looping through the data
			data.items.map((el, index) => {

				// set this variable in order to use it only if labelValue is true
				const label = el.labelValue && `
					<div class='aside-filter-map__label js-aside-label'>
						<span class='aside-filter-map__label-heading'>
							${el.labelValue}€
						</span>
						<br>
						<span class='aside-filter-map__label-posheading'>
							${el.labelCopy}
						</span>
					</div>
				`
				//save card structure in a variable
				cardsAsideFilterMap =
					`
						<li class='aside-filter-map__item js-aside-item' data-aside-item-latitude=${el.latitude}
						data-aside-item-longitude=${el.longitude}>
							<a class='aside-filter-map__item-wrap' href='${el.href}'>
								<div class='aside-filter-map__item-slider'>
									<div class='aside-filter-map__item-flex-between d-none-md'>
										<div class='aside-filter-map__item-flex-between-left'>
											<svg class='aside-filter-map__svg' width='15' height='15' xmlns='http://www.w3.org/2000/svg'>
												<path
													d='M7.008 13.457a27.198 27.198 0 012.854.041l.346.026c1.59.133 3.224.43 4.792.976L7.486.5 0 14.5l.52-.138.614-.144.819-.171.998-.18.753-.114.816-.105.87-.089c.15-.013.301-.026.454-.037l1.164-.065z'
													fill='#429DDC' fill-rule='evenodd' />
											</svg>
						
											<div class='aside-filter-map__item-beforeheading'>${el.beforeHeading}</div>
										</div>
										<div class='aside-filter-map__item-flex-between-right'>
											<div class='aside-filter-map__item-caption'>${el.caption}</div>
										</div>
									</div>
									<div class='aside-filter-map__item-heading d-none-md'>${el.heading}</div>
									<div class='aside-filter-map__item-slider-wrap'>
										<div class='swiper-container js-slider' data-slider-loop='true'>
											<div class='swiper-wrapper'>
												
											</div>
											<div class='swiper-button-next'></div>
											<div class='swiper-button-prev'></div>
											<div class='swiper-pagination'></div>
										</div>
									</div>
								</div>
								<div class='aside-filter-map__item-content'>
									<div class='aside-filter-map__item-flex-between d-none-sm'>
										<div class='aside-filter-map__item-flex-between-left'>
											<svg class='aside-filter-map__svg' width='15' height='15' xmlns='http://www.w3.org/2000/svg'>
												<path
													d='M7.008 13.457a27.198 27.198 0 012.854.041l.346.026c1.59.133 3.224.43 4.792.976L7.486.5 0 14.5l.52-.138.614-.144.819-.171.998-.18.753-.114.816-.105.87-.089c.15-.013.301-.026.454-.037l1.164-.065z'
													fill='#429DDC' fill-rule='evenodd' />
											</svg>
											<div class='aside-filter-map__item-beforeheading'>${el.beforeHeading}</div>
										</div>
										<div class='aside-filter-map__item-flex-between-right'>
											<div class='aside-filter-map__item-caption js-aside-caption'>${el.caption}</div>
										</div>
									</div>
									<div class='aside-filter-map__item-heading d-none-sm js-aside-heading'>${el.heading}</div>
									<div class='aside-filter-map__item-copy'>${el.copy}</div>
									<div class='aside-filter-map__item-footer'>
										<div class='aside-filter-map__item-footer-left'>
											${label}
										</div>
										<div class='aside-filter-map__item-flex-footer-right'>
											<div class='aside-filter-map__badge js-aside-badge'>
												<span
													class='aside-filter-map__badge-underline'>${el.badgeUnderline} 
												</span>
												<span
													class='aside-filter-map__badge-value js-aside-badge-value'>${el.badgeValue} 
												</span>
												<span
													class='aside-filter-map__badge-copy'>${el.badgeCopy}
												</span>
											</div>
										</div>
									</div>
								</div>
							</a>
						</li>
					`
				// insert wrap container inside container (aside-filter-map__list) that is already in the DOM
				document.querySelector('.aside-filter-map__list').insertAdjacentHTML('beforeend', cardsAsideFilterMap);

				// loop through data with slider image in order to build the slider
				[...el.imageSlider].map(el => {
					imageSliderItem = `
						<div class='swiper-slide'>
							<figure	class='aside-filter-map__item-slider-figure'>
								<img 
									class='aside-filter-map__item-slider-image img-fluid js-aside-image'
									src='${el.src}' alt='${el.alt}'
								>
							</figure>
						</div>
					`
					// insert each slider in swiper-wrapper right after create swiper-slide
					document.querySelectorAll('.aside-filter-map__item')[index].querySelector('.swiper-wrapper').insertAdjacentHTML('beforeend', imageSliderItem)

				})
				// load swiper - in order to make swiper slider work
				loadEventSliders.fxInitSlider(document.querySelectorAll('.js-slider')[index])
			})

			// PAGINATION
			const paginationContainer = document.querySelector('.js-filter-pagination')
			paginationContainer.innerHTML = ''
			// check if there is pagination
			if (data.numberOfPages > 0) {
				// first we remove all pagination build before
				// loop through numberOfPages in order to create each item element
				for (let i = 0; i < data.numberOfPages; i++) {
					paginationContainer.innerHTML += `<button class='aside-filter-map__pagination-item js-filter-pagination-item' type='button' data-aside-filter-pagination='${i + 1}'>${i + 1}</button>`
				}

				for (const pageItems of document.querySelectorAll('.js-filter-pagination-item'))
					pageItems.addEventListener('click', e => {
						this.fxUpdatePagination(e.currentTarget)
						scrollOnEvent.fxScrollSmoothOnEvent(document.querySelector('.aside-filter-map'))
					})

				document.querySelector(`[data-aside-filter-pagination="${this.vars.currentPage}"]`).classList.add('active')
			}
		}
	},

	fxRenderMarkersOnMapResults(response, data) {
		// check if map element is the one with markers
		if (!this.el.mapWithMarker) return

		// init map
		const map = loadEventGoogleMaps.fxLoadMap(this.el.mapWithMarker)

		// this is for map initialization with all markers on viewport
		const bounds = new google.maps.LatLngBounds()

		// set variables with null value
		let cardMap
		let imageSliderItemMapCard
		let markers = []
		let infoWindows = []

		// image marker icon default
		const imageMarker = {
			url: this.el.mapWithMarker.dataset.mapMarkerImage
		}

		// image marker icon hovered or selected
		const imageMarkerHovered = {
			url: this.el.mapWithMarker.dataset.mapMarkerImageHovered
		}

		// reset all markers
		markers.forEach(el => el.setMap(null))

		// responsible for toggle markers and info windows on click
		function handleToggleMarkersAndInfoWindows() {
			markers.forEach(el => el.setIcon(imageMarker))
			infoWindows.forEach(el => el.close())
		}

		// responsible for toggle only markers
		function handleToggleOnlyMarkers() {
			markers.forEach(el => el.setIcon(imageMarker))
		}

		// responsible for change markers on hover each card item on aside
		document.querySelectorAll('.js-aside-item').forEach(el => {
			el.addEventListener('mouseenter', e => {
				const heading = e.currentTarget.querySelector('.js-aside-heading').textContent
				markers.find(marker => {
					if (marker.title === heading) {
						marker.setIcon(imageMarkerHovered)
					}
					else {
						marker.setIcon(imageMarker)
					}
				})
			})
		})

		// check if status is success
		if (response.status === 200) {

			// loop through data, build markers and cardsMap (called here as infoWindow)
			data.itemsMap.map(el => {
				// set this variable in order to use it only if labelValue is true
				const labelMapCard = el.labelValue && `
					<div class='card-map__label'>
						<span class='card-map__label-heading'>${el.labelValue}€</span>
						<br>
						<span class='card-map__label-posheading'>${el.labelCopy}</span>
					</div>
				`
				// set this variable in order to build each swiper slide
				const wrapSliders = [...el.imageSlider].map(el => {
					imageSliderItemMapCard = `
						<div class='swiper-slide'>
							<div class='card-map__slider-item'>
								<figure class='card-map__slider-item-figure'>
									<img
										class='card-map__slider-item-image img-full-width'
										src='${el.src}' alt='${el.alt}'
									>
								</figure>
							</div>
						</div>
					`
					return imageSliderItemMapCard
				})

				// build cardMap on markers
				cardMap =
					`
					<a class='card-map' href='${el.href}'>
						<div class='card-map__header'>
							<div class='card-map__slider'>
								<div class='swiper-container js-slider' data-slider-loop='true'>
									<div class='swiper-wrapper'>
										${wrapSliders}
									</div>
									<div class='swiper-pagination '></div>
								</div>
							</div>
							<div class='card-map__row'>
								${labelMapCard}
							</div>
						</div>
						<div class='card-map__body'>
							<div class='card-map__flex'>
								<svg class='card-map__svg' width='15' height='15' xmlns='http://www.w3.org/2000/svg'>
								<path
									d='M7.008 13.457a27.198 27.198 0 012.854.041l.346.026c1.59.133 3.224.43 4.792.976L7.486.5 0 14.5l.52-.138.614-.144.819-.171.998-.18.753-.114.816-.105.87-.089c.15-.013.301-.026.454-.037l1.164-.065z'
									fill='#429DDC' fill-rule='evenodd' />
								</svg>
								
								<div class='card-map__beforeheading'>${el.beforeHeading}</div>
							</div>
							<div class='card-map__heading'>${el.heading}</div>
							<div class='card-map__caption'>${el.caption}</div>
						</div>
						<div class='card-map__footer'>
							<div class='card-map__badge'>
								<span class='card-map__badge-underline'>${el.badgeUnderline} </span>
								<span class='card-map__badge-value'>${el.badgeValue}</span>
								<span class='card-map__badge-copy'>	${el.badgeCopy}	</span>
							</div>
						</div>
					</a>
				`

				// transform latitude and longitude to Number
				const lat = Number(el.latitude)
				const lng = Number(el.longitude)

				// set markers options
				const markerOptions = {
					position: {
						lat,
						lng
					},
					map,
					icon: imageMarker,
					title: el.heading,
					animation: google.maps.Animation.DROP,
					optimized: false
				}

				// create marker instance
				const marker = new google.maps.Marker()
				// set options of markers
				marker.setOptions(markerOptions)

				// set infoWindow options
				const infoWindowOptions = {
					content: cardMap,
					maxWidth: 240
				}

				// Create an info window instance
				const infoWindow = new google.maps.InfoWindow()
				// set options of infoWindow
				infoWindow.setOptions(infoWindowOptions)

				// LISTENERS
				// click listener on each marker - it opens infoWindow, change icon of marker to hovered, set zom on map 
				marker.addListener('click', () => {

					handleToggleMarkersAndInfoWindows()
					marker.setIcon(imageMarkerHovered)
					map.setZoom(8)

					infoWindow.open({
						anchor: marker,
						map,
						shouldFocus: true
					})
				})

				// mouseover listener on each marker - it change marker icon to hovered
				marker.addListener('mouseover', () => {
					handleToggleOnlyMarkers()
					marker.setIcon(imageMarkerHovered)
				})

				// this make sure that infoWindow and markers selected before are set to default
				infoWindows.push(infoWindow)
				markers.push(marker)

				// map click listener - it closes all infoWindows and set markers to default
				map.addListener('click', () => {
					marker.setIcon(imageMarker)
					infoWindow.close()
				})

				// map drag listener - it closes all infoWindows and set markers to default
				map.addListener('drag', () => {
					marker.setIcon(imageMarker)
					infoWindow.close()
				})

				// infoWindow listener - domready - it makes sure that infoWindow hide close button and initialize swiper
				infoWindow.addListener('domready', () => {
					document.querySelectorAll('.gm-style-iw-d')[0].style.overflow = 'auto'
					document.querySelectorAll('.js-slider').forEach(el => loadEventSliders.fxInitSlider(el))
					map.setCenter(map.getCenter())
				})

				// this get position of each marker
				bounds.extend(marker.getPosition())
				// and set bounds to map in order to show markers on viewport
				map.fitBounds(bounds)
			})
		}
	},

	fxGetFilterID(filterId) {
		// find filter type from parameter and get filter ID
		return document.querySelector(`[data-filter-type='${filterId}'`).getAttribute('data-filter-id')
	},

	fxFilter(el) {
		// check if element exists
		if (!el) return

		// set variables let (let it change)
		let filterRegion
		let filterLocation
		let filterCategories

		// populate variables
		filterRegion = this.fxGetFilterID('region')
		filterLocation = this.fxGetFilterID('location')
		filterCategories = this.fxGetFilterID('category')

		// get endpoint
		const endpoint = el.getAttribute('data-action-filter-map')

		// get language that has to be sent to api
		const languageParameter = this.el.body.getAttribute('data-language')

		// set formData
		const formData = {
			region: filterRegion ? filterRegion : 'all',
			location: filterLocation ? filterLocation : 'all',
			category: filterCategories ? filterCategories : 'all',
			page: this.vars.currentPage
		}

		// callback function 
		const callback = (response, data) => {
			// call function that will build cards
			this.fxRenderAsideResults(response, data)

			// call function that will build map markers
			this.fxRenderMarkersOnMapResults(response, data)

			// call function that will fill summary results
			this.fxRenderSummaryResults(response, data)
		}

		// call api
		http.fxPost(endpoint, formData, callback, languageParameter)
	},

	events() {
		// Responsible for all events on select and radio buttons
		this.el.filterInputAndSelectListener.forEach(el => el.addEventListener('change', e => this.fxHandleFilterOnChangeSelectOrInput(e)))

		// Responsible for filter on load page
		window.addEventListener('load', () => this.fxFilter(this.el.mainContainer))
	},

	init() {
		this.events()
	}
}

serviceFilterAsideMap.init()